import React, { useState } from "react";
import { faCheck, faExpandArrowsAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IKImage } from "imagekitio-react";
import { Timer } from "../Quiz/Timer";
import CertificatePreview from "../ContentPlayerNavbar/CertificatePreview";
import './index.css'

const Milestones = () => {
  const [isPreview, setisPreview] = useState(false);

 const MilestoneElements = [
    {
      id: 1,
      on_top: true,
      design_element: (
        <div className="flex w-full   items-center justify-start">
        
          <div className="text-sm line-through opacity-[40%]">
            Signup on LearnTube
          </div>
          
        </div>
      ),
    },
    {
      id: 2,
      on_top: true,
      design_element: (
        <div className="mt-12 flex w-full -ml-4 items-start justify-start">
          <div
            className="flex w-full items-center justify-between rounded-xl border-2 border-[#54BB6C] px-4 py-1 text-sm milestone-box-shadow"
          >
            <p className="font-medium">Complete a quiz</p>
            <div className="">
              <Timer className={"leading-tight"} />
            </div>
          </div>
        </div>
      ),
    },
    {
      id: 3,
      on_top: true,
      design_element: (
        <div className="z-50 -ml-16 mt-8 flex w-[115%] items-center justify-start">
          <div
            className="flex  w-full items-center justify-start rounded-xl border-2 border-gray-300 bg-white px-4 py-2 text-sm opacity-[80%] shadow-xl milestone-box-shadow"
          >
            <img
              urlEndpoint="https://assets.learntube.ai/files/"
              src={
                "https://assets.learntube.ai/files/PRICING/img3.svg?updatedAt=1658852702475"
              }
              transformation={[
                {
                  height: "110",
                  width: "110",
                },
              ]}
              className="mr-6 h-[57px]"
            />
            <div className="">Full-Access Unlocked</div>
          </div>
        </div>
      ),
    },
    {
      id: 4,
      on_top: true,
      design_element: (
        <div className="mt-11 flex   w-full items-center justify-start">
          <div className="text-sm line-through opacity-[40%]">
            Complete The Micro-Skill in 1 day
          </div>
        </div>
      ),
    },
    {
      id: 5,
      on_top: true,
      design_element: (
        <div className="z-50 -ml-16 mt-8 flex w-[115%] items-center justify-start">
          <div
            className="flex  w-full items-center justify-start rounded-xl  border-2 border-gray-300 bg-white px-4 py-2 text-sm shadow-xl milestone-box-shadow"
          >
            <div className="relative mr-6">
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src={
                  "https://assets.learntube.ai/files/TEST/Certificate_Templates/certificate.jpg?updatedAt=1679994833384"
                }
                transformation={[
                  {
                    height: "110",
                    width: "110",
                  },
                ]}
                className="cursor-pointer w-28 h-16"
              />
              <FontAwesomeIcon
                  icon={faExpandArrowsAlt}
                  size="sm"
                  className="text-white absolute top-1 right-1 cursor-pointer"
                  onClick={(e)=>setisPreview(true)}
                />
            </div>
            <div className="opacity-[60%] cursor-pointer">
              Micro-skill certificate unlocked for free
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="flex justify-start items-start">
      <div className="my-8 self-start pl-6">
          {MilestoneElements.map((item, index) => (
            
              <div className="flex flex-col justify-center relative items-center">
                <FontAwesomeIcon
                icon={faCheck}
                className={`mr-4 h-3 w-3 rounded-full ${index === 0 ? 'bg-[#54BB6C]' : 'bg-gray-400'} p-1 text-white`}
                />
                {index!==5 && <div className={`w-[9px] ${index===0 ? 'bg-[#F6C948]' : 'bg-[#EBEBEB]'} ${index===2 ? 'h-18' : 'h-16'} -ml-4`}></div>}
              </div>
          
          ))}
          
      </div>
          <div className="flex flex-col my-8">
         {MilestoneElements.map((item, index) => (
            
              <div className="flex flex-col justify-center w-full items-center">
                {item?.design_element}
              </div>
          
          ))}
          </div>
      
      <CertificatePreview
        isModalEnabled={isPreview}
        setIsModalEnabled={setisPreview}
      />
    </div>
  );
};

export default Milestones;
